let currentToken: string | null = null;

/** Set by the active auth mode (OIDC user-loaded, dev-auth injection, etc.). */
export function setToken(token: string | null): void {
  currentToken = token;
}

/** Read synchronously by RTK Query's prepareHeaders. */
export function getToken(): string | null {
  return currentToken;
}
